import { render, staticRenderFns } from "./CollectingReceiptNoForm.vue?vue&type=template&id=861305cc"
import script from "./CollectingReceiptNoForm.vue?vue&type=script&lang=js"
export * from "./CollectingReceiptNoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports